import {useEffect} from "react";
import {router, usePage} from "@inertiajs/react";
import {useAllStore} from "@/Stores/useAllStore";
import {useSearchStore} from "@/Stores/Site/Search";
import {selectGetSearchData} from "@/Stores/Site/Search/Selectors";

export default function usePressPopstateButton(props) {
    const {stores = {}} = props;
    const {basketStore = {}, catalogStore = {}} = stores;
    const {url} = usePage();

    const popstateButton = useAllStore((state) => state.popstateButton);
    const setPopstateButton = useAllStore((state) => state.setPopstateButton);
    const searchStoreGetSearchData = useSearchStore(selectGetSearchData);

    useEffect(() => {
        if (popstateButton) {
            if (url.includes('catalog') && !url.includes('product')) {
                catalogStore.getCatalogData(true);
            } else if (url.includes('basket')) {
                basketStore.getBasket(true);
            } else if (url.includes('go-to-checkout')) {
                basketStore.getBasketGoToCheckout(true);
            } else if (url.includes('search')) {
                searchStoreGetSearchData(true);
            } else {
                // По кнопкам назад вперед всегда запрашиваем данные с сервера
                router.reload();
            }
        }

        setPopstateButton();
    }, []);
}
